import { createSelector } from '@reduxjs/toolkit';
import moment from 'moment';
import { initialSharesState, sharesApi } from 'services/api/shares/queries';
import { AccessSharingRole } from 'types/entities/AccessSharingRole';

const selectSharesResult = sharesApi.endpoints.getShares.select();

const selectSharesData = createSelector(
  selectSharesResult,
  result => result.data ?? initialSharesState,
);

export interface UpcomingShareDisplayItem {
  id: string;
  itemName: string;
  ownerName: string;
  ownerEmail: string;
  startsAt: string;
  myRole: string;
}

export const selectUpcomingAccessShares = createSelector(
  [selectSharesData, (_, email?: string) => email],
  (data, email) => {
    if (!email) return [];

    const allItems = [...data.fleets, ...data.equipment];

    return allItems
      .flatMap((item): UpcomingShareDisplayItem[] => {
        const details = item.sharedItemDetails;

        if (details.myRole === AccessSharingRole.Owner) {
          return [];
        }

        const myShareRecord = item.sharedWith.find(
          share => share.email.toLowerCase() === email.toLowerCase(),
        );

        if (!myShareRecord || !myShareRecord.startsAt) {
          return [];
        }

        const startsAt = moment(myShareRecord.startsAt);
        if (!startsAt.isValid() || startsAt.isSameOrBefore(moment(), 'day')) {
          return [];
        }

        return [
          {
            id: myShareRecord.exposedAccessSharingRecordId,
            itemName: details.sharedItemLabel,
            ownerName: details.ownerName,
            ownerEmail: details.ownerEmail,
            startsAt: myShareRecord.startsAt,
            myRole: details.myRole,
          },
        ];
      })
      .sort((a, b) => moment(a.startsAt).diff(b.startsAt));
  },
);
